/**
 * @ngdoc directive
 * @name Date Range Selector
 *
 * @description
   Shows date range selector
 *
 * @scope
 * @param {Object} dateRange - { start: momemt(), end: moment(), caption: 'Caption' }
 * @param {Array} defaultDateRanges - list of date ranges available to select
 * @param {Object} callback - on date range change
 * @param {Moment/String} minDate - min date in moment or 'YYYY-MM-DD' format
 * @param {Moment/String} maxDate - max date in moment or 'YYYY-MM-DD' format
 * @param {Object} customDateRange - object that holds customDateRange
 * @param {String} opens - align date range picker ('left'/'right'/'center' are available)
 *
 * @example
    <date-range-selector
      date-range="{ start: '2017-01-01', end: '2017-02-15' }"
      default-date-ranges="[{ start: '2017-01-01', end: '2017-01-15', caption: 'January 2017' }]"
      callback="onDateRangeChange(dateRange)"
      min-date='"2016-01-01"'
      max-date='"2018-01-01"'>
    </date-range-selector>
*/

(function () {
  'use strict';

  directive.$inject = ["PATH"];
  app.directive('dateRangeSelector', directive);

  function directive(PATH) {
    controller.$inject = ["$scope", "$element", "dateRangeService", "$timeout", "screenSizeService", "$rootScope", "localStorageService"];
    return {
      restrict: 'E',
      templateUrl: PATH.components + 'dateRangeSelector/template.html',
      scope: {
        dateRange: '=',
        defaultDateRanges: '=',
        callback: '&',
        minDate: '=?',
        maxDate: '=?',
        customDateRange: '=?',
        opens: '@'
      },
      controller: controller
    };

    function controller($scope, $element, dateRangeService, $timeout, screenSizeService, $rootScope, localStorageService) {
      var userInfo = localStorageService.get('userInfo');
      var format = 'MM/DD/YYYY';
      var isSafari = navigator.userAgent.indexOf('Safari') > -1;
      $scope.getCaption = function () {
        if (!$scope.dateRange.start || !$scope.dateRange.end) return;

        var selectedRange = _.find($scope.defaultDateRanges, function (range) {
          return moment(range.start).isSame($scope.dateRange.start, 'day') &&
              moment(range.end).isSame($scope.dateRange.end, 'day');
        });
        if (selectedRange) {
          return selectedRange.caption;
        }
        return moment($scope.dateRange.start).format(format) + ' - ' + moment($scope.dateRange.end).format(format);
      };

      $scope.isValid = function () {
        var res = false;

        if (($scope.dateRange) && ($scope.dateRange.startDate !== undefined) && ($scope.dateRange.endDate !== undefined)) {
          if (typeof $scope.dateRange.startDate === 'string') {
            $scope.dateRange.startDate = moment($scope.dateRange.startDate, format);
          }

          if (typeof $scope.dateRange.endDate === 'string') {
            $scope.dateRange.endDate = moment($scope.dateRange.endDate, format);
          }

          res = ($scope.dateRange.startDate === null || $scope.dateRange.startDate.isValid())
            && ($scope.dateRange.endDate === null || $scope.dateRange.endDate.isValid());
        }

        return res;
      };

      function updateRange(dateRange, noChanges) {
        if ((dateRange) && (dateRange.startDate !== undefined) && (dateRange.endDate !== undefined)) {
          $scope.dateRange.start = dateRange.startDate;
          $scope.dateRange.end = dateRange.endDate;
          if (!noChanges) {
            $scope.callback({ dateRange: $scope.dateRange, noChanges: noChanges });
          } else if (noChanges) {
            $scope.$apply();
            $scope.getCaption();
          }
        }
      }

      var updateRangeDebounce = _.debounce(updateRange, 100);


      $scope.init = function () {
        var start = $scope.dateRange.start || null;
        var end = $scope.dateRange.end || null;

        $scope.dateRange.startDate = (start && !start._isAMomentObject) ? moment(start) : start;
        $scope.dateRange.endDate = (end && !end._isAMomentObject) ? moment(end) : end;

        $scope.opts = {
          isMobile: screenSizeService.smallerThan('md'),
          screenMode: screenSizeService.screenMode(),
          opens: $scope.opens ? $scope.opens : 'right',
          applyClass: 'btn-primary',
          singleDatePicker: false,
          linkedCalendars: true,
          showDropdowns: false,
          clearLabel: 'Cancel',
          isSafari: isSafari,
          locale: {
            format: format,
            separator: '-',
            cancelLabel: 'Cancel'
          },
          eventHandlers: {
            'cancel.daterangepicker': function () {
              updateRangeDebounce($scope.dateRange, true);
            },
            'apply.daterangepicker': function () {
              updateRangeDebounce($scope.dateRange);
            },
            'show.daterangepicker': function () {
              var dateRangeSelector = $element.find('.date-range-selector');
              var l = dateRangeSelector.val().trim().length;

              var dateRanges = $(document).find('.daterangepicker .ranges li');

              if (l < 1) {
                dateRanges.removeClass('active');
              }

              $('.date-range-selector__input').on('keydown', function (event) {
                var keyCode = event.keyCode || event.which;
                if (keyCode === 9) {
                  event.stopPropagation();
                  event.preventDefault();
                  dateRanges.first().focus();
                }
              });

              $('.daterangepicker.dropdown-menu').keypress(function (event) {
                if (event.which === 13) {
                  $(':focus').trigger('click');
                }
              });
            },
            'hide.daterangepicker': function () {
              $('.daterangepicker.dropdown-menu').unbind('keypress');
              $('.date-range-selector__input').unbind('keydown');
              updateRangeDebounce($scope.dateRange, true);
            }
          }
        };

        $scope.opts.alwaysShowCalendars = !$scope.opts.isMobile;

        // translate ranges in component format
        if ($scope.defaultDateRanges && $scope.defaultDateRanges.length > 0) {
          $scope.opts.ranges = {};
          angular.forEach($scope.defaultDateRanges, function (range, index) {
            $scope.opts.ranges[range.caption] = [range.start, range.end, range, index];
          });
        }
        $rootScope.$on('defaultDateRangeChanged', function (event, data) {
          $scope.defaultDateRanges = data;
          $scope.init();
        });
      };
      $scope.init();
    }
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/dateRangeSelector/directive.js